import { FlatList } from 'react-native'
import {
  BANNERS_LIST,
  FEATURED_PORTRAIT_LIST,
  LIVE_EVENTS,
  POSTERS_LIST,
  POSTERS_LOGO_LIST,
  POSTERS_PORTRAIT_LIST,
  TOP_CHANNELS_LIST,
} from '@mwxltd/flix-api-client'
import { useMediaIs } from '@flix/common/style/media'
import { BannerContent } from './BannerContent/BannerContent.js'
import { PortraitFeaturedContent } from './PortraitFeaturedContent/PortraitFeaturedContent.js'
import { PosterContent } from './PosterContent/PosterContent.js'
import { PosterLandscapeContent } from './PosterLandscapeContent/PosterLandscapeContent.js'
import { PosterLogoLandscapeContent } from './PosterLogoLandscapeContent/PosterLogoLandscapeContent.js'
import { PremiereFeaturedContent } from './PremiereFeaturedContent/PremiereFeaturedContent.js'

const getContentComponent = ({ listType }, landscapePosters, sm) => {
  switch (listType) {
    default:
    case POSTERS_LIST:
      return landscapePosters && sm ? PosterLandscapeContent : PosterContent
    case POSTERS_LOGO_LIST:
      return PosterLogoLandscapeContent
    case POSTERS_PORTRAIT_LIST:
      return PosterContent
    case FEATURED_PORTRAIT_LIST:
      return PortraitFeaturedContent
    case BANNERS_LIST:
      return BannerContent
    case LIVE_EVENTS:
      return PosterLandscapeContent
    case TOP_CHANNELS_LIST:
      return PremiereFeaturedContent
  }
}

export const HorizontalLists = ({
  items = [],
  itemProps,
  onItemChosen,
  isFocused,
  landscapePosters,
  landscapeLiveList,
}) => {
  const sm = useMediaIs('sm')

  const renderItem = ({ item }) => {
    if (!item) return null

    const ContentComponent = getContentComponent(item, landscapePosters, sm)
    return (
      <ContentComponent
        key={item.slug}
        {...item}
        itemProps={itemProps}
        onItemChosen={onItemChosen}
        showArrows={sm}
        isFocused={isFocused}
        landscapeLiveList={landscapeLiveList}
      />
    )
  }

  return (
    <FlatList
      data={items}
      initialNumToRender={3}
      renderItem={renderItem}
      keyExtractor={(item, index) => index.toString()}
    />
  )
}
